const API_BASE_URL = "https://admin.oavlite.com";
// const API_BASE_URL = "https://oavlite.royalblackstone.net";

export default API_BASE_URL;
